import { useState } from "react";
import { services_constants } from "./constants";

const Services = () => {
  const [activeService, setActiveService] = useState("");

  return (
    <section className="py-[54px] relative overflow-hidden bg-white bg-cover bg-no-repeat bg-landing-services">
      <div className="container  px-3">
        <div className="text-center mb-16 ">
          <h2 className="text-[#222] text-[24px] md:text-[40px] font-bold md:font-medium">
            {services_constants.title}
          </h2>
          <p className="text-[#222] md:text-xl max-w-[536px] mx-auto">
            {services_constants.description}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {services_constants.services.map((service) => {
            const isActive = activeService === service.id;
            return (
              <div
                key={service.id}
                className={`py-3 px-4 rounded-zl border-[0.5px] cursor-pointer transition-all duration-300 hover:shadow flex flex-col rounded-[12px] gap-3 ${
                  isActive
                    ? "bg-[#EDF8FF] border-primary_alt text-[#222] "
                    : "bg-transparent  border-[#E5E5E5]  text-gray-900 hover:border-gray-300"
                }`}
                onClick={() => setActiveService(service.id)}
                onMouseEnter={() => setActiveService(service.id)}
              >
                <div
                  className={`flex justify-center items-center h-12 w-12 rounded-[28px] border-[8px] ${
                    isActive
                      ? " border-[#E7ECFC] bg-primary_alt"
                      : " border-[#E5E5E5]"
                  }`}
                >
                  {service.icon(isActive)}
                </div>
                <div className="space-y-1">
                  <h3 className="text-xl md:text-[24px] font-medium text-[#222]">
                    {service.title}
                  </h3>
                  <p className="text-[15px] text-[#222] w-full">
                    {service.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
